<template>
  <div class="procect-files" id="procect-files">
    <div class="p-left">
      <div class="p-left-top">
        <div class="card card1">
          <div class="card-header">
            <div class="card-title"><div>基本信息</div></div>
            <div class="card-more" @click="baseInfoDialog = true">
              查看更多
              <i class="el-icon-d-arrow-right"></i>
            </div>
          </div>
          <div class="card-content">
            <div class="xm">
              <div @click="openKhda(0)">{{ currentXm.xmmc }}</div>
              <img
                src="../../img/select.png"
                alt=""
                width="18"
                @click="xmDialog = true"
              />
              <!-- <i class="el-icon-arrow-right" @click="xmDialog = true"></i> -->
            </div>
            <div class="item">
              <div class="label">
                <div>合同起止时间：</div>
                <div>{{ baseInfo.htqsrq }}-{{ baseInfo.htzzrq }}</div>
              </div>
            </div>
            <div class="item">
              <div class="label">
                <div>管理归属部门：</div>
                <div>{{ baseInfo.glgsbm }}</div>
              </div>

              <div class="label">
                <div>销售归属部门：</div>
                <div>{{ baseInfo.xsgsbm }}</div>
              </div>
            </div>
            <div class="item">
              <div class="label">
                <div>项目所属阶段：</div>
                <div>{{ baseInfo.ssjd }}</div>
              </div>
              <div class="label">
                <div>所属区域总监：</div>
                <div>{{ baseInfo.qyzj }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card2">
          <div class="card-header">
            <div class="card-title"><div>年度规划</div></div>
            <div class="card-more" @click="openProgram()">
              查看更多<i class="el-icon-d-arrow-right"></i>
            </div>
          </div>
          <div class="card-content">
            <div>
              <div class="item" style="color: #036eb8">
                <div>完成率</div>
                <div>{{ programInfo.wcl.wcs }}/{{ programInfo.wcl.zs }}</div>
              </div>
              <div class="progress">
                <el-progress
                  :text-inside="true"
                  :stroke-width="20"
                  :percentage="programInfo.wcl.wcl"
                  status="success"
                ></el-progress>
              </div>
            </div>
            <div>
              <div class="item" style="color: #d9001b">
                <div>延期率</div>
                <div>{{ programInfo.yql.yyq }}/{{ programInfo.yql.zs }}</div>
              </div>
              <div class="progress">
                <el-progress
                  :text-inside="true"
                  :stroke-width="20"
                  :percentage="programInfo.yql.yql"
                  status="success"
                  color="#d9001b"
                ></el-progress>
              </div>
            </div>
            <div class="box-wrap">
              <div class="box">
                <div>{{ programInfo.jxz }}</div>
                <div>进行中</div>
              </div>
              <div class="box">
                <div>{{ programInfo.yyq }}</div>
                <div>已延期</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card3">
          <div class="card-header">
            <div class="card-title">
              <el-dropdown @command="setMonthYf">
                <span
                  class="el-dropdown-link"
                  style="font-size: 16px; font-weight: 700; color: #000"
                >
                  {{ monthParams.month }}任务<i
                    class="el-icon-arrow-down el-icon--right"
                  ></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in monthList"
                    :key="item"
                    style="padding: 0 20px"
                    :command="item"
                    >{{ item }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="card-more" @click="openPlan()">
              查看更多<i class="el-icon-d-arrow-right"></i>
            </div>
          </div>
          <div class="card-content">
            <el-tabs
              stretch
              type="border-card"
              tab-position="left"
              style="height: 260px; margin-top: 10px"
              @tab-click="setMonthStatus"
              v-model="monthParams.status"
            >
              <el-tab-pane
                :label="`进行中 ${monthInfo.jxz}`"
                name="2"
                style="padding: 0 10px; text-align: left"
              ></el-tab-pane>
              <el-tab-pane
                :label="`总任务 ${monthInfo.zrw}`"
                name="0"
                style="padding: 0 10px; text-align: left"
              ></el-tab-pane>
              <el-tab-pane
                name="-1"
                :label="`已延期 ${monthInfo.yyq}`"
                style="padding: 0 10px; text-align: left"
              ></el-tab-pane>

              <!-- <el-tab-pane
                :label="`延期率 ${parseInt(monthInfo.yql)}%`"
                style="padding: 0 10px; text-align: left"
                name="5"
              ></el-tab-pane>
              <el-tab-pane
                :label="`完成率 ${parseInt(monthInfo.wcl)}%`"
                style="padding: 0 10px; text-align: left"
                name="3,6"
              ></el-tab-pane> -->
              <div>
                <el-table
                  :data="monthRwTableList"
                  fit
                  highlight-current-row
                  :default-sort="{ prop: 'date', order: 'descending' }"
                  tooltip-effect="dark"
                >
                  <template slot="empty">
                    <div class="nodata">
                      <img src="@/img/nodata.png" alt="" width="160" />
                      <div>暂无数据</div>
                    </div>
                  </template>
                  <el-table-column
                    label="任务名称"
                    align="left"
                    prop="taskname"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="执行人"
                    align="left"
                    prop="executor"
                    :show-overflow-tooltip="true"
                  >
                    <template slot="header">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="橙色字体表示客户方人员"
                        placement="top"
                      >
                        <div>
                          执行人&nbsp;
                          <img src="@/img/tips.png" width="16" alt="" />
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <div>
                        <span
                          style="color: #f59a23"
                          v-if="scope.row.executorgxr"
                        >
                          {{ scope.row.executorgxr }}
                        </span>
                        {{ scope.row.executor }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tabs>
          </div>
        </div>
      </div>
      <div class="p-left-bottom">
        <div class="card card4" style="min-height: 572px">
          <div class="card-header">
            <div class="card-title"><div>项目工作</div></div>
            <div class="card-more" @click="openXmgz()">
              查看更多<i class="el-icon-d-arrow-right"></i>
            </div>
          </div>
          <div class="card-content" style="height: 480px; overflow: auto">
            <el-tabs v-model="xmgzTabsVal">
              <el-tab-pane label="质量检查" name="gcjc" v-if="showXmzk">
                <el-table
                  :data="tableData"
                  fit
                  highlight-current-row
                  :default-sort="{ prop: 'date', order: 'descending' }"
                  tooltip-effect="dark"
                  ref="table1"
                >
                  <template slot="empty">
                    <div class="nodata">
                      <img src="@/img/nodata.png" alt="" width="160" />
                      <div>暂无数据</div>
                    </div>
                  </template>

                  <el-table-column
                    label="指标名称"
                    align="center"
                    prop="zbmc"
                    min-width="200px"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="检查频率"
                    align="center"
                    prop="jcpl"
                    min-width="100px"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="执行情况"
                    align="center"
                    prop="zxqk"
                    min-width="350px"
                    :show-overflow-tooltip="true"
                  >
                    <template slot="header">
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div slot="content">
                          合格：任务已按要求完成，并达到预定的标准和要求。<br />
                          不合格：任务未能按要求完成，无法达到预定的标准和要求。<br />
                          未开始：任务或工作尚未启动或还未进入实施阶段。<br />
                          未完成：任务或工作已经开始，但尚未完成。<br />
                          豁免：项目特殊情况<br />
                          其余情况均为空<br />
                        </div>
                        <div class="table_header">
                          执行情况&nbsp;
                          <img src="@/img/u285.svg" height="16" alt="" />
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span
                        v-for="item in scope.row.zxqk"
                        :key="item.id"
                        style="margin-right: 10px"
                      >
                        <el-button
                          @click="handleViewRz(item.rzList)"
                          v-if="item.zxjgmc"
                          size="mini"
                          :style="{
                            background:
                              item.zxjgmc == '合格'
                                ? '#036eb8'
                                : item.zxjgmc == '不合格'
                                ? '#E13349'
                                : item.zxjgmc == '未完成'
                                ? '#f7b967'
                                : '#bbb',
                            color: '#fff',
                            border: 'none',
                            width: '70px',
                          }"
                          >{{ item.zxjgmc }}
                          <i
                            class="el-icon-warning-outline"
                            v-if="item.fhtgcs && item.fhtgcs >= 1"
                          ></i>
                        </el-button>
                        <div v-else>{{ item.sjjg }}</div>
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane name="jgz">
                <span slot="label">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="最近一个月的工作量统计"
                    placement="top"
                  >
                    <div>
                      记工作&nbsp;
                      <!-- <img src="@/img/tips.png" width="16" alt="" /> -->
                    </div>
                  </el-tooltip></span
                >
                <el-table
                  :data="gzlList"
                  fit
                  empty-text="0"
                  highlight-current-row
                  :default-sort="{ prop: 'date', order: 'descending' }"
                  tooltip-effect="dark"
                >
                  <template slot="empty">
                    <div class="nodata">
                      <img src="@/img/nodata.png" alt="" width="160" />
                      <div>暂无数据</div>
                    </div>
                  </template>
                  <el-table-column
                    label="条线"
                    align="left"
                    prop="txlx"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="维秘记工作总天数"
                    align="left"
                    prop="zgz"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <div
                        style="color: #036eb8; cursor: pointer"
                        @click="handleCilckGzlmxDialog(scope.row, 1)"
                      >
                        {{ scope.row.zgz }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="条线占比"
                    align="left"
                    prop="txzb"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="计划内总天数"
                    align="left"
                    prop="jhn"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <div
                        style="color: #036eb8; cursor: pointer"
                        @click="handleCilckGzlmxDialog(scope.row, 2)"
                      >
                        {{ scope.row.jhn ? scope.row.jhn : 0 }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="计划内工作量占比"
                    align="left"
                    prop="jhnzb"
                    :show-overflow-tooltip="true"
                    ><template slot-scope="scope">
                      {{ scope.row.jhnzb ? scope.row.jhnzb : "0%" }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="周报" name="zb">
                <div>
                  <el-radio-group v-model="zbRadio" @input="handleChagetime">
                    <el-radio label="2">上周</el-radio>
                    <el-radio label="1">本周</el-radio>
                  </el-radio-group>
                </div>
                <div style="margin-top: 30px">
                  <el-tabs
                    v-model="zbChildRadio"
                    tab-position="left"
                    v-if="zbRadio == 1"
                    type="border-card"
                    stretch
                    style="height: 370px; margin: 5px"
                    class="zbChildTabs"
                  >
                    <el-tab-pane label="本周投入" name="1">
                      <el-table
                        :data="bztrList"
                        fit
                        highlight-current-row
                        :default-sort="{ prop: 'date', order: 'descending' }"
                        tooltip-effect="dark"
                      >
                        <template slot="empty">
                          <div class="nodata">
                            <img src="@/img/nodata.png" alt="" width="160" />
                            <div>暂无数据</div>
                          </div>
                        </template>
                        <el-table-column
                          label="姓名"
                          align="left"
                          prop="xm"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="岗位"
                          align="left"
                          prop="gwmc"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="项目负责人"
                          align="left"
                          prop="xmjs"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="本周投入"
                          align="left"
                          prop="bzgzl"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="本月投入"
                          align="left"
                          prop="bygzl"
                          :show-overflow-tooltip="true"
                        /> </el-table
                    ></el-tab-pane>
                    <el-tab-pane label="本周进展" name="2">
                      <el-table
                        :data="bzjzList"
                        fit
                        highlight-current-row
                        :default-sort="{ prop: 'date', order: 'descending' }"
                        tooltip-effect="dark"
                      >
                        <template slot="empty">
                          <div class="nodata">
                            <img src="@/img/nodata.png" alt="" width="160" />
                            <div>暂无数据</div>
                          </div>
                        </template>
                        <el-table-column
                          label="姓名"
                          align="left"
                          prop="xm"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="条线"
                          align="left"
                          prop="txlx"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="本周投入"
                          align="left"
                          prop="bzgzl"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="工作内容"
                          align="left"
                          prop="content"
                          :show-overflow-tooltip="true"
                        >
                          <template slot-scope="scope">
                            <div v-html="scope.row.content"></div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="下周计划" name="3">
                      <el-table
                        :data="xzjhList"
                        fit
                        highlight-current-row
                        :default-sort="{ prop: 'date', order: 'descending' }"
                        tooltip-effect="dark"
                      >
                        <template slot="empty">
                          <div class="nodata">
                            <img src="@/img/nodata.png" alt="" width="160" />
                            <div>暂无数据</div>
                          </div>
                        </template>
                        <el-table-column
                          label="工作内容"
                          align="left"
                          prop="gznr"
                          :show-overflow-tooltip="true"
                        >
                          <template slot-scope="scope">
                            <div v-html="scope.row.gznr"></div>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="责任人"
                          align="left"
                          prop="xm"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="计划完成时间"
                          align="left"
                          prop="endtime"
                          :show-overflow-tooltip="true"
                        />
                      </el-table>
                    </el-tab-pane>
                  </el-tabs>
                  <el-tabs
                    v-model="zbChildRadio"
                    tab-position="left"
                    v-if="zbRadio == 2"
                    type="border-card"
                    stretch
                    style="height: 370px; margin: 5px"
                    class="zbChildTabs"
                  >
                    <el-tab-pane label="上周投入" name="1">
                      <el-table
                        :data="bztrList"
                        fit
                        highlight-current-row
                        :default-sort="{ prop: 'date', order: 'descending' }"
                        tooltip-effect="dark"
                      >
                        <template slot="empty">
                          <div class="nodata">
                            <img src="@/img/nodata.png" alt="" width="160" />
                            <div>暂无数据</div>
                          </div>
                        </template>
                        <el-table-column
                          label="姓名"
                          align="left"
                          prop="xm"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="岗位"
                          align="left"
                          prop="gwmc"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="项目负责人"
                          align="left"
                          prop="xmjs"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="本周投入"
                          align="left"
                          prop="bzgzl"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="本月投入"
                          align="left"
                          prop="bygzl"
                          :show-overflow-tooltip="true"
                        /> </el-table
                    ></el-tab-pane>
                    <el-tab-pane label="上周进展" name="2">
                      <el-table
                        :data="bzjzList"
                        fit
                        highlight-current-row
                        :default-sort="{ prop: 'date', order: 'descending' }"
                        tooltip-effect="dark"
                      >
                        <template slot="empty">
                          <div class="nodata">
                            <img src="@/img/nodata.png" alt="" width="160" />
                            <div>暂无数据</div>
                          </div>
                        </template>
                        <el-table-column
                          label="姓名"
                          align="left"
                          prop="xm"
                          :show-overflow-tooltip="true" />
                        <el-table-column
                          label="条线"
                          align="left"
                          prop="txlx"
                          :show-overflow-tooltip="true" />
                        <el-table-column
                          label="本周投入"
                          align="left"
                          prop="bzgzl"
                          :show-overflow-tooltip="true" />
                        <el-table-column
                          label="工作内容"
                          align="left"
                          prop="content"
                          :show-overflow-tooltip="true"
                        >
                          <template slot-scope="scope">
                            <div v-html="scope.row.content"></div>
                          </template> </el-table-column></el-table
                    ></el-tab-pane>
                    <el-tab-pane label="本周计划" name="3">
                      <el-table
                        :data="xzjhList"
                        fit
                        highlight-current-row
                        :default-sort="{ prop: 'date', order: 'descending' }"
                        tooltip-effect="dark"
                      >
                        <template slot="empty">
                          <div class="nodata">
                            <img src="@/img/nodata.png" alt="" width="160" />
                            <div>暂无数据</div>
                          </div>
                        </template>
                        <el-table-column
                          label="工作内容"
                          align="left"
                          prop="gznr"
                          :show-overflow-tooltip="true"
                        >
                          <template slot-scope="scope">
                            <div v-html="scope.row.gznr"></div>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="责任人"
                          align="left"
                          prop="xm"
                          :show-overflow-tooltip="true"
                        />
                        <el-table-column
                          label="计划完成时间"
                          align="left"
                          prop="endtime"
                          :show-overflow-tooltip="true"
                        />
                      </el-table>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <div class="p-right">
      <div class="card card5">
        <div class="card-header">
          <div class="card-title"><div>财务状况</div></div>
          <div class="card-time">
            <div
              :class="cwzkActive == 1 ? 'active' : ''"
              @click="handleChangeCwzkTime(1)"
            >
              月
            </div>
            <div
              :class="cwzkActive == 2 ? 'active' : ''"
              @click="handleChangeCwzkTime(2)"
            >
              季
            </div>
            <div
              :class="cwzkActive == 3 ? 'active' : ''"
              @click="handleChangeCwzkTime(3)"
            >
              年
            </div>
          </div>
          <div class="card-more" @click="toWm()">
            查看更多<i class="el-icon-d-arrow-right"></i>
          </div>
        </div>
        <div class="card-content">
          <div class="wrap">
            <div style="position: relative">
              <div>
                <div @click="cwzkInfo.active = !cwzkInfo.active">
                  {{ cwzkInfo.active ? cwzkInfo.hkje.num : "*******" }}
                </div>
              </div>
              <div @click="getXmHkInfo()">项目回款</div>
              <!-- <div class="cwzk-more"><i class="el-icon-d-arrow-right" /></div> -->
            </div>
            <div style="position: relative">
              <div @click="cwzkInfo.active = !cwzkInfo.active">
                {{ cwzkInfo.active ? cwzkInfo.kpye.num : "*******" }}
              </div>
              <div @click="getXmWsInfo()">已开票未收款</div>
              <!-- <div class="cwzk-more"><i class="el-icon-d-arrow-right" /></div> -->
            </div>
            <div>
              <div @click="cwzkInfo.active = !cwzkInfo.active">
                {{ cwzkInfo.active ? cwzkInfo.gzlcb.num : "*******" }}
              </div>
              <div @click="getGzlcbInfo()">工作量成本</div>
            </div>
            <div>
              <div @click="cwzkInfo.active = !cwzkInfo.active">
                {{ cwzkInfo.active ? cwzkInfo.mnlr.num : "*******" }}
              </div>
              <div @click="getMnlrInfo()">模拟利润</div>
            </div>
          </div>
          <div class="bx">
            <div>
              <div @click="cwzkInfo.active = !cwzkInfo.active">
                {{ cwzkInfo.active ? cwzkInfo.xmbx.num : "*******" }}
              </div>
              <div @click="getXmbxInfo()">项目报销</div>
            </div>
          </div>
        </div>
      </div>
      <div class="card card6">
        <div class="card-header">
          <div class="card-title"><div>最近高管拜访</div></div>
          <div class="card-more" @click="openGgft()">
            查看更多<i class="el-icon-d-arrow-right"></i>
          </div>
        </div>
        <div class="card-content">
          <div>
            <el-table
              :data="ggbfList"
              fit
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
            >
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="150" />
                  <div>暂无数据</div>
                </div>
              </template>
              <el-table-column
                label="拜访时间"
                align="left"
                prop="bfrq"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="拜访人员"
                align="left"
                prop="bfryxm"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="拜访对象"
                align="left"
                prop="bfdx"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="拜访时长"
                align="left"
                prop="gtsc"
                :show-overflow-tooltip="true"
              />
            </el-table>
          </div>
        </div>
      </div>

      <div class="card card7">
        <div class="card-header">
          <div class="card-title">
            <div>项目团队</div>
          </div>
          <div v-if="xmtdTabs == 0">
            <el-button
              label="left"
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="openKhda(1)"
              >干系人</el-button
            >
          </div>
        </div>
        <div class="card-content">
          <div>
            <el-tabs v-model="xmtdTabs">
              <el-tab-pane label="客户方" name="0">
                <el-table
                  :data="xmtdList.khlist"
                  fit
                  highlight-current-row
                  :default-sort="{ prop: 'date', order: 'descending' }"
                  tooltip-effect="dark"
                  style="height: 210px; overflow: auto"
                >
                  <template slot="empty">
                    <div class="nodata">
                      <img src="@/img/nodata.png" alt="" width="150" />
                      <div>暂无数据</div>
                    </div>
                  </template>
                  <el-table-column
                    label="姓名"
                    align="left"
                    prop="name"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <div style="color: #f59a23">
                        {{ scope.row.name }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="职位"
                    align="left"
                    prop="zw"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="电话"
                    align="left"
                    prop="sjhm"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <div style="color: #036eb8">
                        {{ scope.row.sjhm }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="绩效管家绑定"
                    align="center"
                    prop="id"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <div
                        :style="{ color: scope.row.id ? '#333' : '#D9001B' }"
                      >
                        {{ scope.row.id ? "是" : "否" }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="公司方" name="1">
                <el-table
                  :data="xmtdList.tianweilist"
                  fit
                  highlight-current-row
                  :default-sort="{ prop: 'date', order: 'descending' }"
                  tooltip-effect="dark"
                  style="height: 210px; overflow: auto"
                >
                  <template slot="empty">
                    <div class="nodata">
                      <img src="@/img/nodata.png" alt="" width="150" />
                      <div>暂无数据</div>
                    </div>
                  </template>
                  <el-table-column
                    label="姓名"
                    align="left"
                    prop="name"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="职位"
                    align="left"
                    prop="zw"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="电话"
                    align="left"
                    prop="phone"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <div style="color: #036eb8">
                        {{ scope.row.phone }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="基础信息"
      :visible.sync="baseInfoDialog"
      width="500px"
      :closeOnClickModal="false"
      v-if="baseInfoDialog"
      class="baseInfoDialog"
    >
      <div class="baseInfo">
        <div class="card-content">
          <div class="item">项目名称</div>
          <div class="xm" @click="openKhda(0)">{{ baseInfo.xmmc }}</div>
          <div class="item">客户名称</div>
          <div class="kh" @click="openKhda(0)">{{ baseInfo.khmc }}</div>
          <div class="item">
            <div class="label">
              <div>合同开始时间</div>
              <div>{{ baseInfo.htqsrq }}</div>
            </div>
            <div class="value">
              <div>合同结束时间</div>
              <div>{{ baseInfo.htzzrq }}</div>
            </div>
          </div>
          <div class="item">
            <div class="label">
              <div>管理归属部门</div>
              <div>{{ baseInfo.glgsbm }}</div>
            </div>
            <div class="value">
              <div>销售归属部门</div>
              <div>{{ baseInfo.xsgsbm }}</div>
            </div>
          </div>
          <div class="item">
            <!-- <div class="label">
              <div>项目合同类型</div>
              <div>{{ baseInfo.htlx }}</div>
            </div>
            <div class="value">
              <div>项目合同状态</div>
              <div>{{ baseInfo.htzt }}</div>
            </div> -->
            <div class="label">
              <div>项目类型</div>
              <div>{{ baseInfo.xmlxmc }}</div>
            </div>
            <div class="value">
              <div>项目状态</div>
              <div>{{ baseInfo.xmztmc }}</div>
            </div>
          </div>
          <div class="item">
            <div class="label">
              <div>项目所属阶段</div>
              <div>{{ baseInfo.ssjd }}</div>
            </div>
            <div class="value">
              <div>所属区域总监</div>
              <div>{{ baseInfo.qyzj }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="xmDialog"
      width="90%"
      :closeOnClickModal="false"
      v-if="xmDialog"
      class="xmDialog"
    >
      <div>
        <div class="xmDialog-header">
          <el-input
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="projectParams.xmmc"
            style="width: 30%"
            clearable
            @input="getSearchXm()"
          >
          </el-input>

          <el-select
            v-model="projectParams.xmlx"
            placeholder="请选择"
            style="width: 30%"
            clearable
            @change="getXm()"
          >
            <el-option
              v-for="item in xmlxOptions"
              :key="item.dictValue"
              :label="`${item.dictValue} - ${item.dictLabel}`"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>

          <el-select
            v-model="projectParams.xmzt"
            placeholder="请选择"
            style="width: 30%"
            clearable
            @change="getXm()"
          >
            <el-option
              v-for="item in xmztOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
          <!-- <el-button type="primary" @click="getXm">搜索</el-button> -->
        </div>
        <div class="xmDialog-content">
          <el-tabs tab-position="left" v-model="xmTabsListIndex">
            <el-tab-pane
              :label="item.bmmc + '(' + item.xmList.length + ')'"
              v-for="(item, index) in projectList"
              :key="index"
              style="max-height: 400px; overflow-y: auto"
              :name="item.bmmc"
            >
              <div
                class="xm_item"
                v-for="(item2, index2) in item.xmList"
                :key="index2"
                @click="handeleClickProject(item2)"
              >
                {{ item2.xmmc }}
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="`${
        cwzkActive == 1 ? '当月' : cwzkActive == 2 ? '当季' : '当年'
      }回款明细`"
      :visible.sync="xmhkDialog"
      width="90%"
      :closeOnClickModal="false"
      v-if="xmhkDialog"
      class="xmhkDialog"
    >
      <el-table
        :data="xmHkList"
        fit
        show-summary
        :summary-method="getSummaries1"
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
        <el-table-column
          label="发票号码"
          align="left"
          prop="fphm"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="开票日期"
          align="left"
          prop="kprq"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="开票金额（元）"
          align="right"
          prop="kpje"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              {{ formatWithMod(Number(scope.row.kpje).toFixed(2)) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="开票税额（元）"
          align="right"
          prop="kpse"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              {{ formatWithMod(Number(scope.row.kpse).toFixed(2)) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="回款日期"
          align="center"
          prop="hkrq"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="回款金额（元）"
          align="right"
          prop="money"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              {{ formatWithMod(Number(scope.row.money).toFixed(2)) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :title="`${
        cwzkActive == 1 ? '当月' : cwzkActive == 2 ? '当季' : '当年'
      }应回款明细`"
      :visible.sync="ykpwskDialog"
      width="90%"
      :closeOnClickModal="false"
      v-if="ykpwskDialog"
      class="ykpwskDialog"
    >
      <el-table
        :data="wskList"
        fit
        show-summary
        :summary-method="getSummaries2"
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
        <el-table-column
          label="发票号码"
          align="left"
          prop="fphm"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="开票日期"
          align="left"
          prop="kprq"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="开票金额（元）"
          align="right"
          prop="kpje"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              {{ formatWithMod(Number(scope.row.kpje).toFixed(2)) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="开票税额（元）"
          align="right"
          prop="kpse"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              {{ formatWithMod(Number(scope.row.kpse).toFixed(2)) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="应回款金额（元）"
          align="right"
          prop="kpye"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div style="color: #d9001b">
              {{ formatWithMod(Number(scope.row.kpye).toFixed(2)) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      title="工作量成本明细"
      :visible.sync="gzlcbDialog"
      width="90%"
      :closeOnClickModal="false"
      v-if="gzlcbDialog"
      class="gzlcbDialog"
    >
      <div>
        统计周期
        <el-date-picker
          v-model="gzlcbTime[0]"
          style="width: 150px"
          type="date"
          size="small"
          placeholder="开始日期"
          :pickerOptions="pickerOptions"
        ></el-date-picker
        >&nbsp; &nbsp;- &nbsp; &nbsp;
        <el-date-picker
          v-model="gzlcbTime[1]"
          style="width: 150px"
          type="date"
          size="small"
          placeholder="结束日期"
          :pickerOptions="pickerOptions"
        ></el-date-picker>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getGzlcbInfo()"
            style="margin: 0 15px"
            >查询</el-button
          >
          <el-button
            icon="el-icon-download"
            size="small"
            @click="handleExport()"
            style="margin-left: 4px"
            >导出</el-button
          >
        </span>
      </div>

      <el-table
        :data="gzlcbList"
        fit
        show-summary
        :summary-method="getSummaries3"
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
        <el-table-column
          label="分公司"
          align="left"
          prop="bmmc"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="项目名称"
          align="left"
          prop="xmmc"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="姓名"
          align="left"
          prop="ygxm"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="所属条线"
          align="left"
          prop="txlx"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="项目投入时间（天）"
          align="right"
          sortable
          prop="gzsj"
          min-width="150"
          :show-overflow-tooltip="true"
        /><el-table-column
          label="资质等级"
          align="left"
          sortable
          prop="zzdj"
          :show-overflow-tooltip="true"
        /><el-table-column
          label="成本核算级别"
          align="left"
          prop="cbhsjb"
          :show-overflow-tooltip="true"
        /><el-table-column
          label="岗位标准费用（元）"
          align="right"
          prop="money"
          :show-overflow-tooltip="true"
          min-width="150"
        >
          <template slot-scope="scope">
            <div>
              {{ formatWithMod(Number(scope.row.money).toFixed(2)) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="项目决算成本（元）"
          align="right"
          prop="jscb"
          sortable
          :show-overflow-tooltip="true"
          min-width="150"
        >
          <template slot-scope="scope">
            <div>
              {{ formatWithMod(Number(scope.row.jscb).toFixed(2)) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="模拟利润明细"
      :visible.sync="mnlrDialog"
      width="90%"
      :closeOnClickModal="false"
      v-if="mnlrDialog"
      class="mnlrDialog"
    >
      <el-table
        :data="mnlrList"
        fit
        show-summary
        :summary-method="getSummaries4"
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
        <el-table-column
          label="月份"
          align="left"
          prop="yf"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="项目回款（元）"
          align="right"
          prop="xmhk"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              {{ formatWithMod(Number(scope.row.xmhk).toFixed(2)) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="工作量成本（元）"
          align="right"
          prop="gzlcb"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              {{ formatWithMod(Number(scope.row.gzlcb).toFixed(2)) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="项目报销（元）"
          align="right"
          prop="xmbx"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              {{ formatWithMod(Number(scope.row.xmbx).toFixed(2)) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="模拟利润（元）"
          align="right"
          prop="mnlr"
          :show-overflow-tooltip="true"
        >
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="模拟利润 = 项目回款 - 工作量成本 - 项目报销"
              placement="top"
            >
              <div>
                模拟利润（元）&nbsp;
                <img src="@/img/tips.png" width="16" alt="" />
              </div>
            </el-tooltip>
          </template>

          <template slot-scope="scope">
            <div>
              {{ formatWithMod(Number(scope.row.mnlr).toFixed(2)) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      title="项目报销"
      :visible.sync="xmbxDialog"
      width="500"
      :closeOnClickModal="false"
      v-if="xmbxDialog"
      class="xmbxDialog"
    >
      <div v-if="xmbxList && xmbxList.length > 0">
        <div class="xmbx-count">
          合计：{{ formatWithMod(Number(xmbxCount).toFixed(2)) }}
        </div>
        <div id="xmbx-box"></div>
      </div>

      <div v-else>
        <div class="nodata">
          <img src="@/img/nodata.png" alt="" width="160" />
          <div>暂无数据</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="工作量明细"
      :visible.sync="gzlmxDialog"
      width="90%"
      :closeOnClickModal="false"
      v-if="gzlmxDialog"
      class="gzlmxDialog"
    >
      <div>
        <el-radio-group v-model="gzlmxParams.gzlTime" @input="handelChangeTime">
          <el-radio-button :label="time.jyy">近一月</el-radio-button>
          <el-radio-button :label="time.bz">本周</el-radio-button>
          <el-radio-button :label="time.by">本月</el-radio-button>
          <el-radio-button :label="time.bj">本季</el-radio-button>
          <el-radio-button :label="time.bn">本年</el-radio-button>
        </el-radio-group>
        <span style="margin: 0 10px 0 30px">统计周期</span>
        <el-date-picker
          v-model="gzlTjtime[0]"
          style="width: 150px"
          type="date"
          size="small"
          placeholder="开始日期"
          :pickerOptions="pickerOptions"
          @change="onChangeGzlTjtime"
        ></el-date-picker
        >&nbsp; &nbsp;- &nbsp; &nbsp;
        <el-date-picker
          v-model="gzlTjtime[1]"
          style="width: 150px"
          type="date"
          size="small"
          placeholder="结束日期"
          :pickerOptions="pickerOptions"
          @change="onChangeGzlTjtime"
        ></el-date-picker>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getGzlmxInfo()"
            style="margin: 0 15px"
            >查询</el-button
          >
        </span>
      </div>
      <el-table
        :data="gzlmxList"
        fit
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
        max-height="400px"
      >
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
        <el-table-column
          label="员工姓名"
          align="left"
          prop="xm"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="岗位名称"
          align="left"
          prop="gwmc"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="所属部门"
          align="left"
          prop="bmmc"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="签到日期"
          align="left"
          prop="qdrq"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="星期几"
          align="left"
          prop="whatday"
          :show-overflow-tooltip="true"
        /><el-table-column
          label="工作时间（天）"
          align="left"
          prop="gzsj"
          :show-overflow-tooltip="true"
        /><el-table-column
          label="审核状态"
          align="left"
          prop="state"
          :show-overflow-tooltip="true"
        /><el-table-column
          label="内容"
          align="left"
          prop="content"
          min-width="200"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.content"></div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="gzlmxParams.page"
        :page-size="gzlmxParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="gzlmxCount"
        @size-change="handleSizeChangeGzl"
        @current-change="handleCurrentChangeGzl"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getDict } from "@/api/common";
import { getHtlx } from "@/api/xmcbhs.js";
import {
  getProjectList,
  getProjectBaseInfo,
  getNdProgram,
  getDyTask,
  getXmggbflist,
  getXmtd,
  getXmgzlList,
  getXmtrlist,
  getCwzk,
  getXmjzlist,
  getXzjzlist,
  getProjectWorkLoad,
  getXmHkList,
  getXmWsList,
  getGzlcbList,
  detailExport,
  getMnlrList,
  getXmbxList,
  toWm,
} from "@/api/projectFiles.js";
import { getXmList, getZkjgList } from "@/api/xmzk";
import moment from "moment";
import * as echarts from "echarts";
import { getMyDate, formatWithMod } from "@/utils/utils";
export default {
  name: "projectFiles",
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      projectParams: {
        xmmc: null,
        xmlx: "DS",
        xmzt: "1",
      },
      currentXm: {
        xmbh: null,
        xmmc: "",
      },
      projectList: [],
      baseInfo: {},
      programInfo: {
        wcl: {},
        yql: {},
      },
      monthParams: {
        month: "",
        status: "2",
      },
      monthList: [], //[一月，二月，....]
      monthInfo: {
        jxz: 0,
        wcl: "0.00",
        yql: "0.00",
        yyq: 0,
        zrw: 0,
      },
      monthRwTableList: [],
      ggbfList: [],
      xmtdList: {
        khlist: [],
        tianweilist: [],
      },
      gzlList: [],
      xmgzTabsVal: "jgz",
      zbRadio: "2",
      zbChildRadio: "1",
      time: {
        bz: null, //本周
        sz: null, //上周
        jyy: null, //近一月
        by: null, //本月
        bj: null, //本季
        bn: null, //本年
      },
      bztrList: [],
      bzjzList: [],
      xzjhList: [],

      weeklyIndex: "1",

      gzlmxParams: {
        gzlTime: "",
        txlx: null,
        type: null,
        jsrq: null,
        qsrq: null,
        page: 1,
        pageSize: 10,
      },
      cwzkInfo: {
        active: false,
        hkje: {
          num: 0,
        },
        kpye: {
          num: 0,
        },
        gzlcb: {
          num: 0,
        },
        mnlr: {
          num: 0,
        },
        xmbx: {
          num: 0,
        },
      },
      xmHkList: [],
      gzlmxList: [],
      gzlmxCount: 0,
      wskList: [],
      gzlcbList: [],
      gzlcbTime: [],
      gzlcbParams: {
        xmbh: "",
        qsrq: null,
        qsrq: null,
      },
      mnlrList: [],
      xmbxList: [],
      baseInfoDialog: false,
      xmDialog: false,
      xmhkDialog: false,
      ykpwskDialog: false,
      gzlcbDialog: false,
      mnlrDialog: false,
      xmbxDialog: false,
      gzlmxDialog: false,
      cwzkActive: 1,
      xmtdTabs: "0",
      xmlxOptions: [],
      xmztOptions: [],
      gzlTjtime: [],
      xmbxCount: 0,
      tableData: [],
      xmInfo: {},
      showXmzk: false,
      xmTabsListIndex: "广州",
    };
  },
  created() {
    for (let i = 0; i < 12; i++) {
      this.monthList.push(moment().month(i).format("MMMM"));
      if (moment().month(i).format("MMMM") == moment().format("MMMM")) {
        this.monthParams.month = moment().format("MMMM");
        break;
      }
    }
    if (this.$route.params.xmbh && this.$route.params.xmbh != "null") {
      this.currentXm.xmbh = this.$route.params.xmbh;
      this.getXm(this.currentXm.xmbh);
    } else {
      // if (!this.user.xm) {
      this.$store.dispatch("common/fetchUserInfoAction").then((res) => {
        if (res.code == 0) {
          this.currentXm.xmbh = res.data?.xmbh ? res.data.xmbh : null;
          this.getXm(this.currentXm.xmbh);
        }
      });
      // } else {
      //   this.getXm();
      // }
    }

    this.time = getMyDate();
    getDict("htgl_xmlx", 2).then((res) => {
      if (res.code == 0) {
        this.xmlxOptions = res.data;
        // 去掉售前
        for (let i in this.xmlxOptions) {
          if ("SQ" == this.xmlxOptions[i].dictValue) {
            this.xmlxOptions.splice(i, 1);
          }
        }
      }
    });
    getDict("xmgl_xmzt", 2).then((res) => {
      if (res.code == 0) {
        this.xmztOptions = res.data;
      }
    });
  },
  mounted() {
    // 项管左侧收起
    window.parent.postMessage("tower-" + this.$route.params.xmbh, "*");
  },
  methods: {
    getCaption(obj, text) {
      let index = obj.lastIndexOf(text) + text.length - 1;
      obj = obj.substring(index + 1, obj.length);
      return obj;
    },
    getAllData() {
      this.getBaseInfo();
      this.getNdProgramInfo();
      //   this.getMonthInfo();
      this.getGgbfInfo();
      this.getXmtdInfo();
      this.getXmgzlInfo();
      this.getBzzbInfo(this.time.sz);
      this.getCwzkInfo();
      this.getZkjgListData();
      this.getXmListData();
      let status = null;
      if (this.monthParams.status == 0) {
        status = "";
      } else if (this.monthParams.status == -1) {
        status = 5;
      } else {
        status = this.monthParams.status;
      }
      getDyTask({
        xmbh: this.currentXm.xmbh,
        status,
        month: this.monthParams.month,
      }).then((res) => {
        if (res.code == 0) {
          //当月无数据取上月数据，一月除外
          const len = this.monthList.length;
          if (res.data && res.data.zrw) {
            this.monthInfo = res.data;
            this.monthRwTableList = res.data?.rw;
          } else {
            if (len > 2) {
              if (this.monthParams.month == this.monthList[len - 2]) {
                this.monthInfo = {
                  jxz: 0,
                  wcl: "0.00",
                  yql: "0.00",
                  yyq: 0,
                  zrw: 0,
                };
                return;
              }
              this.monthParams.month = this.monthList[len - 2];
              this.getMonthInfo();
            } else {
              this.monthInfo = res.data;
              if (res.data?.rw) {
                this.monthRwTableList = res.data?.rw;
              }
            }
          }
        }
      });
    },
    getXm(xmbh) {
      getProjectList(this.projectParams).then((res) => {
        if (res.code == 0) {
          this.projectList = res.data;
          for (let i in this.projectList) {
            if (this.projectList[i]?.xmList?.length > 0) {
              this.xmTabsListIndex = this.projectList[i].bmmc;
              break;
            }
          }
          if (!this.xmTabsListIndex) {
            this.xmTabsListIndex = "广州";
          }
          if (!this.currentXm.xmbh) {
            let projectListRandom = 0;
            let xmListRandom = 0;
            projectListRandom = Math.round(
              Math.random() * (this.projectList.length - 1)
            );
            xmListRandom = Math.round(
              Math.random() *
                (this.projectList[projectListRandom]?.xmList.length - 1)
            );
            this.currentXm =
              this.projectList[projectListRandom]?.xmList[xmListRandom];
            this.getAllData();
          }
          if (xmbh) {
            this.currentXm.xmbh = xmbh;
            this.getAllData();
          }
        }
      });
    },
    getSearchXm() {
      this.projectParams.xmlx = null;
      this.getXm();
    },
    getBaseInfo() {
      getProjectBaseInfo({ xmbh: this.currentXm.xmbh }).then((res) => {
        if (res.code == 0) {
          this.baseInfo = res.data;
          this.currentXm.xmmc = res.data.xmmc;
        }
      });
    },
    handeleClickProject(item) {
      this.currentXm = item;
      this.xmDialog = false;
      this.getAllData();
    },
    openProgram() {
      if (this.programInfo.programid) {
        var dataUrl = `/projectPlan/program/viewProgram?programId=${this.programInfo.programid}&
          programName=${this.programInfo.name}&status=${this.programInfo.status}&
          xmbh=${this.programInfo.xmbh}&year=${this.programInfo.year}`;
        var menuName = this.programInfo.name;
      } else {
        // var dataUrl = "/projectPlan/program/search";
        // var menuName = "项目规划";
        this.$message.error("该项目暂未制定规划!");
      }
      var dataIndex = 9901;

      var data = { dataIndex, dataUrl, menuName };
      // window.parent.menuItemInPage(dataUrl, dataIndex, menuName);
      window.parent.postMessage(data, "*");
    },
    toWm() {
      toWm({ xmbh: this.currentXm.xmbh, url: "main/sktj/list" }).then((res) => {
        // const p = { xmbh: this.currentXm.xmbh, url: "main/sktj/list" };
        if (res.code == 0) {
          window.open(res.data, "_blank");
        }
      });
    },

    openPlan() {
      if (this.monthInfo.planid) {
        var dataUrl = `/projectPlan/plan/viewTask?planId=${this.monthInfo.planid}&planName=${this.monthInfo.planname}&status=${this.monthInfo.planstatus}`;
        var menuName = this.monthInfo.planname;
      } else {
        // var dataUrl = "/projectPlan/plan/search";
        // var menuName = "项目计划";
        this.$message.error("该项目此月份暂未制定计划!");
      }
      var dataIndex = 9901;

      var data = { dataIndex, dataUrl, menuName };
      // window.parent.menuItemInPage(dataUrl, dataIndex, menuName);
      window.parent.postMessage(data, "*");
    },
    openGgft() {
      var dataUrl = `/project/interview?xmbh=${this.baseInfo.khbh}`;
      var menuName = "项目高管拜访管理";
      var dataIndex = 9902;

      var data = { dataIndex, dataUrl, menuName };
      // window.parent.menuItemInPage(dataUrl, dataIndex, menuName);
      window.parent.postMessage(data, "*");
    },
    openKhda(type) {
      var dataUrl = `/file/customer?xmbh=${this.currentXm.xmbh}&isSy=${type}`;
      var menuName = "客户档案";
      var dataIndex = 9902;

      var data = { dataIndex, dataUrl, menuName };
      // window.parent.menuItemInPage(dataUrl, dataIndex, menuName);
      window.parent.postMessage(data, "*");
    },
    // 项目工作跳转
    openXmgz() {
      if (this.xmgzTabsVal == "jgz") {
        var dataUrl = `/weekly/works?xmbh=${
          this.currentXm.xmbh
        }&qsrq=${this.time.jyy.slice(0, 8)}&jsrq=${this.time.jyy.slice(9, 17)}`;
        var menuName = "记工作";
        var dataIndex = 9902;

        var data = { dataIndex, dataUrl, menuName };
        // window.parent.menuItemInPage(dataUrl, dataIndex, menuName);
        window.parent.postMessage(data, "*");
      } else if (this.xmgzTabsVal == "zb") {
        var data = {
          xmbh: this.currentXm.xmbh,
          xmjc: this.currentXm.xmmc,
          xmzq: this.time.bz,
        };
        var dataUrl =
          "/menuRedirect?systemType=tmis-pmp&redireType=tmis&menuType=2&menuParams=" +
          encodeURI(JSON.stringify(data));
        var menuName = this.currentXm.xmmc + "周报";
        var dataIndex = 9902;
        var data = { dataIndex, dataUrl, menuName };
        window.parent.postMessage(data, "*");
      } else {
        var dataUrl = `/menuRedirect?systemType=tmis-pmp&redireType=tmis&menuType=40&zk_xmbh=${this.currentXm.xmbh}`;
        var menuName = "质量检查";
        var dataIndex = Math.round(Math.random() * 10000);
        localStorage.setItem("zk_xmbh", this.currentXm.xmbh);
        var data = { dataIndex, dataUrl, menuName };
        window.parent.postMessage(data, "*");
      }
    },

    getNdProgramInfo() {
      getNdProgram({ xmbh: this.currentXm.xmbh }).then((res) => {
        if (res.code == 0 && res.data) {
          this.programInfo = res.data;

          if (res.data?.wcl?.wcl) {
            this.programInfo.wcl.wcl = parseInt(this.programInfo.wcl?.wcl);
          } else {
            this.programInfo.wcl.wcl = 0;
          }
          if (res.data?.yql?.yql) {
            this.programInfo.yql.yql = parseInt(this.programInfo.yql?.yql);
          } else {
            this.programInfo.yql.yql = 0;
          }
        } else {
          this.programInfo = {
            wcl: {},
            yql: {},
          };
        }
      });
    },
    setMonthStatus(e) {
      const params = { status: e.name.trim() };
      this.monthParams = { ...this.monthParams, ...params };
      this.getMonthInfo();
    },
    setMonthYf(e) {
      const params = { month: e };
      this.monthParams = { ...this.monthParams, ...params };
      this.getMonthInfo();
    },
    getMonthInfo() {
      let status = null;
      if (this.monthParams.status == 0) {
        status = "";
      } else if (this.monthParams.status == -1) {
        status = 5;
      } else {
        status = this.monthParams.status;
      }
      getDyTask({
        xmbh: this.currentXm.xmbh,
        status,
        month: this.monthParams.month,
      }).then((res) => {
        if (res.code == 0) {
          //当月无数据取上月数据，一月除外
          const len = this.monthList.length;
          this.monthRwTableList = res.data?.rw;

          this.monthInfo = res.data;
          //   if (res.data && res.data.zrw) {
          //   }
        }
      });
    },
    //高管拜访
    getGgbfInfo() {
      getXmggbflist({ xmbh: this.currentXm.xmbh }).then((res) => {
        if (res.code == 0) {
          this.ggbfList = res.data;
        }
      });
    },
    //项目团队
    getXmtdInfo() {
      getXmtd({ xmbh: this.currentXm.xmbh }).then((res) => {
        if (res.code == 0) {
          this.xmtdList = res.data;
        }
      });
    },
    //记工作条线汇总
    getXmgzlInfo() {
      const qsrq = this.time.jyy.slice(0, 8);
      const jsrq = this.time.jyy.slice(9, 17);
      getXmgzlList({ xmbh: this.currentXm.xmbh, qsrq, jsrq }).then((res) => {
        if (res.code == 0) {
          this.gzlList = res.data;
        }
      });
    },

    getBzzbInfo(weekDate) {
      //   if (this.zbRadio == "1") {
      getXmtrlist({
        xmbh: this.currentXm.xmbh,
        weekDate,
      }).then((res) => {
        if (res.code == 0) {
          this.bztrList = res.data;
        }
      });
      getXmjzlist({ xmbh: this.currentXm.xmbh, weekDate }).then((res) => {
        if (res.code == 0) {
          this.bzjzList = res.data;
        }
      });
      getXzjzlist({ xmbh: this.currentXm.xmbh, weekDate }).then((res) => {
        if (res.code == 0) {
          let temp = [];
          for (let i of res.data.data2) {
            // if (this.zbRadio == 1) {
            //   if (i.zq == "下周") {
            //     temp.push(i);
            //   }
            // } else {
            //   if (i.zq == "下周") {
            //     temp.push(i);
            //   }
            // }
            if (i.zq == "下周") {
              temp.push(i);
            }
          }
          this.xzjhList = temp;
        }
      });

      //   }
    },
    getCwzkInfo() {
      getCwzk({ xmbh: this.currentXm.xmbh, type: this.cwzkActive }).then(
        (res) => {
          if (res.code == 0) {
            this.cwzkInfo.hkje.num = res.data?.hkje
              ? formatWithMod(Number(res.data?.hkje).toFixed(2))
              : "0.00";
            this.cwzkInfo.kpye.num = res.data?.kpye
              ? formatWithMod(Number(res.data?.kpye).toFixed(2))
              : "0.00";
            this.cwzkInfo.gzlcb.num = res.data?.gzlcb
              ? formatWithMod(Number(res.data?.gzlcb).toFixed(2))
              : "0.00";
            this.cwzkInfo.mnlr.num = res.data?.mnlr
              ? formatWithMod(Number(res.data?.mnlr).toFixed(2))
              : "0.00";
            this.cwzkInfo.xmbx.num = res.data?.xmbx
              ? formatWithMod(Number(res.data?.xmbx).toFixed(2))
              : "0.00";
          }
        }
      );
    },
    handleChagetime(e) {
      if (e == 1) {
        this.getBzzbInfo(this.time.bz);
      } else {
        this.getBzzbInfo(this.time.sz);
      }
    },
    handleCilckGzlmxDialog(row, type) {
      this.gzlmxDialog = true;

      this.gzlmxParams = {
        txlx: row.txlx == "合计" ? "" : row.txlx,
        type,
        gzlTime: this.time.jyy,
        page: 1,
        pageSize: 10,
      };
      this.handelChangeTime();
      this.getGzlmxInfo();
    },
    getGzlmxInfo(page, pageSize) {
      const params = {
        xmbh: this.currentXm.xmbh,
        txlx: this.gzlmxParams.txlx,
        type: this.gzlmxParams.type,
        qsrq: this.gzlmxParams.gzlTime.slice(0, 8),
        jsrq: this.gzlmxParams.gzlTime.slice(9, 17),
        page: page ? page : this.gzlmxParams.page,
        pageSize: pageSize ? pageSize : this.gzlmxParams.pageSize,
      };

      getProjectWorkLoad(params).then((res) => {
        if (res.code == 0) {
          this.gzlmxList = res.data;
          this.gzlmxCount = res.count;
        }
      });
    },
    onChangeGzlTjtime(e) {
      if (this.gzlTjtime[0] && this.gzlTjtime[1]) {
        this.gzlmxParams.gzlTime =
          moment(this.gzlTjtime[0]).format("YYYYMMDD") +
          "-" +
          moment(this.gzlTjtime[1]).format("YYYYMMDD");
      }
    },
    handelChangeTime() {
      this.gzlTjtime[0] = moment(this.gzlmxParams.gzlTime.slice(0, 8));
      this.gzlTjtime[1] = moment(this.gzlmxParams.gzlTime.slice(9, 17));
    },

    handleSizeChangeGzl(val) {
      this.gzlmxParams.pageSize = val;
      this.getGzlmxInfo();
    },
    handleCurrentChangeGzl(val) {
      this.gzlmxParams.page = val;
      this.getGzlmxInfo();
    },
    getXmHkInfo() {
      this.xmhkDialog = true;
      const params = { xmbh: this.currentXm.xmbh, type: this.cwzkActive };
      getXmHkList(params).then((res) => {
        if (res.code == 0) {
          this.xmHkList = res.data;
        }
      });
    },
    getXmWsInfo() {
      this.ykpwskDialog = true;
      const params = { xmbh: this.currentXm.xmbh, type: this.cwzkActive };
      getXmWsList(params).then((res) => {
        if (res.code == 0) {
          this.wskList = res.data;
        }
      });
    },
    getGzlcbInfo() {
      this.gzlcbDialog = true;
      const params = { xmbh: this.currentXm.xmbh, qsrq: "", jsrq: "" };
      if (this.gzlcbTime[0] && this.gzlcbTime[1]) {
        params.qsrq = moment(this.gzlcbTime[0]).format("YYYYMMDD");
        params.jsrq = moment(this.gzlcbTime[1]).format("YYYYMMDD");
      } else {
        if (this.cwzkActive == 1) {
          params.qsrq = this.time.by.slice(0, 8);
          params.jsrq = this.time.by.slice(9, 17);
        } else if (this.cwzkActive == 2) {
          params.qsrq = this.time.bj.slice(0, 8);
          params.jsrq = this.time.bj.slice(9, 17);
        } else {
          params.qsrq = this.time.bn.slice(0, 8);
          params.jsrq = this.time.bn.slice(9, 17);
        }
      }
      this.gzlcbParams = params;
      getGzlcbList(params).then((res) => {
        if (res.code == 0) {
          this.gzlcbList = res.data;
        }
      });
    },

    handleExport() {
      const params = this.gzlcbParams;
      params.bmbh = "";
      detailExport(params).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    handleChangeCwzkTime(cwzkActive) {
      this.cwzkActive = cwzkActive;
      this.getCwzkInfo();
    },
    getMnlrInfo() {
      this.mnlrDialog = true;
      const params = { xmbh: this.currentXm.xmbh, type: this.cwzkActive };
      getMnlrList(params).then((res) => {
        if (res.code == 0) {
          this.mnlrList = res.data;
        }
      });
    },
    getXmbxInfo() {
      this.xmbxDialog = true;
      const params = { xmbh: this.currentXm.xmbh, type: this.cwzkActive };
      getXmbxList(params).then((res) => {
        if (res.code == 0) {
          this.xmbxList = res.data;
          const data = this.xmbxList.map((val) => {
            return { key: val.kmmc, value: val.fy };
          });
          this.xmbxCount = 0;
          for (let i of data) {
            this.xmbxCount += i.value;
          }

          if (data && data.length > 0) {
            setTimeout(() => {
              this.drawCharts(data);
            }, 100);
          }
        }
      });
    },

    drawCharts(data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("xmbx-box"));

      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: (item) => {
            return `${item.data.key}:${item.data.value} (${item.percent}%)`;
          },
        },

        label: {
          position: "outer",
          alignTo: "labelLine",
          bleedMargin: 30,
          lineHeight: 15,
          fontSize: 12,
          formatter: (item) => {
            return `${item.data.key}：${formatWithMod(
              Number(item.data.value).toFixed(2)
            )}`;
          },
        },
        labelLine: {},
        series: [
          {
            name: "部门",
            type: "pie",
            radius: ["20%", "40%"],
            emphasis: {
              label: {
                // show: false,
                fontSize: "14",
                fontWeight: "bold",
              },
            },
            itemStyle: {
              normal: {
                label: { show: true },
                labelLine: { show: true },
                // color: function (params) {
                //   return colorList[params.dataIndex];
                // },
              },
            },
            data,
          },
        ],
      });
    },
    getSummaries1(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index == 1 || index == 4) {
          sums[index] = "";
          return;
        } else if (index === 0) {
          sums[index] = "合计";
          return;
        } else {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = formatWithMod(Number(sums[index]).toFixed(2));
          } else {
            sums[index] = "";
          }
        }
      });

      return sums;
    },
    getSummaries2(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index == 1) {
          sums[index] = "";
          return;
        } else if (index === 0) {
          sums[index] = "合计";
          return;
        } else {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = formatWithMod(Number(sums[index]).toFixed(2));
          } else {
            sums[index] = "";
          }
        }
      });
      return sums;
    },
    getSummaries3(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (
          index == 1 ||
          index == 2 ||
          index == 3 ||
          index == 5 ||
          index == 6
        ) {
          sums[index] = "";
          return;
        } else if (index === 0) {
          sums[index] = "合计";
          return;
        } else {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = formatWithMod(Number(sums[index]).toFixed(2));
          } else {
            sums[index] = "";
          }
        }
      });
      return sums;
    },
    getSummaries4(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        } else {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = formatWithMod(Number(sums[index]).toFixed(2));
          } else {
            sums[index] = "";
          }
        }
      });
      return sums;
    },
    getZkjgListData() {
      this.loading = true;
      getZkjgList({
        xmbh: this.currentXm.xmbh,
        year: moment().format("YYYY"),
      }).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          this.tableData = res.data.list;
          this.xmInfo = res.data.info;
          const docH = document.documentElement.clientHeight;
          this.height = docH - 150;
          // document.querySelector(".project-select").style.maxHeight =
          //   docH - 52 + "px";
          const timer = setInterval(() => {
            if (this.user?.xm) {
              this.applyRole =
                this.xmInfo?.isxmcy == 1 ||
                this.xmInfo?.xmzj == this.user.xm ||
                this.xmInfo?.qyzj == this.user.xm;
              clearInterval(timer);
            }
          }, 50);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getXmListData() {
      const xmParams = {
        year: moment().format("YYYY"),
      };
      getXmList(xmParams).then((res) => {
        if (res.code == 0) {
          for (let i of res.data) {
            for (let j of i.xmList) {
              if (this.currentXm.xmbh == j.xmbh) {
                this.showXmzk = true;
                this.xmgzTabsVal = this.showXmzk ? "gcjc" : "jgz";
                return;
              } else {
                this.showXmzk = false;
                this.xmgzTabsVal = this.showXmzk ? "gcjc" : "jgz";
              }
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang='less' scoped>
.procect-files {
  min-height: 100%;
  min-width: 1500px;
  background-color: #eef2f8;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
}
.p-left {
  width: 70%;
  margin-right: 10px;
  .p-left-top {
    display: flex;
  }
  .p-left-bottom {
    margin-top: 10px;
  }
}
.p-right {
  width: 30%;
  .card {
    width: 100%;
  }
  .card5 {
    .card-content {
      position: relative;
      margin: 10px 0;
    }
    .wrap {
      display: flex;
      flex-wrap: wrap;
      > div {
        width: calc(50% - 5px);
        text-align: center;
        line-height: 30px;
        padding: 33.5px 0;
        color: #666;
        font-size: 16px;
        font-weight: bold;
        background-color: rgba(249, 217, 201, 1);
        box-sizing: border-box;
        border-radius: 5px;
        margin: 0 10px 10px 0;
        > div {
          cursor: pointer;
        }
      }
      > div:nth-of-type(2) {
        background-color: rgba(209, 227, 244, 1);
        margin: 0 0 10px 0;
      }
      > div:nth-of-type(3) {
        background-color: rgba(249, 217, 231, 1);
        margin: 0 10px 0 0;
      }
      > div:nth-of-type(4) {
        background-color: rgba(221, 214, 252, 1);
        margin: 0;
      }
    }
    .bx {
      color: #666;
      font-size: 16px;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 140px;
      height: 140px;
      margin-top: -70px;
      margin-left: -70px;
      border-radius: 50%;
      padding: 10px;
      text-align: center;
      font-weight: bold;
      z-index: 9;
      box-sizing: border-box;
      background-color: #fff;
      > div {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        align-content: center;
        background-color: #e9f1fb;
        line-height: 32px;
        cursor: pointer;
        border-radius: 50%;
        > div {
          width: 100%;
        }
      }
    }
  }
}
.card1 {
  width: 25%;
  margin-right: 10px;
  height: 325px;

  .card-content {
    margin-top: 10px;
    .xm {
      margin: 20px 0 10px 0;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      color: #036eb8;
      cursor: pointer;
    }
    .item {
      line-height: 44px;
      .label {
        display: flex;
        font-size: 13px;
        > div:nth-of-type(1) {
          width: 100px;
          text-align: right;
        }
        > div:nth-of-type(2) {
          color: #909399;
          padding-left: 10px;
          text-align: right;
          width: calc(100% - 100px);
        }
      }
    }
  }
}
.card2 {
  width: 25%;
  margin-right: 10px;
  height: 325px;
  .card-content {
    .item {
      line-height: 32px;
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
    }
    .box-wrap {
      display: flex;
      justify-content: space-around;
      margin-top: 20px;
      .box {
        width: 37%;
        height: 116px;
        background-color: #f2f2f2;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        text-align: center;
        color: #036eb8;
        border-radius: 5px;
        > div {
          width: 100%;
          height: 28px;
          line-height: 28px;
          font-weight: 700;

          font-size: 16px;
        }
      }
      > .box:nth-of-type(2) {
        color: #d9001b;
      }
    }
  }
}
.baseInfo {
  width: 100%;
  margin: 0;
  .item {
    line-height: 44px;

    .label,
    .value {
      display: flex;
      justify-content: space-between;
      font-size: 13px;
      color: #000;
      > div:nth-of-type(1) {
        width: 80px;
        text-align: right;
      }
      > div:nth-of-type(2) {
        color: #aaa;
      }
    }
  }
  .xm {
    color: #036eb8;
    font-size: 16px;
    line-height: 44px;
  }
  .kh {
    font-size: 16px;
    line-height: 44px;
  }
}
.card3 {
  width: calc(50% - 20px);
  height: 325px;
}
.card5 {
  height: 325px;
}
.card6 {
  margin: 10px 0;
  height: 245px;
}
.card7 {
  //   height: 300px;
  overflow: auto;
}
.card {
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-sizing: border-box;
  .card-header {
    display: flex;
    justify-content: space-between;
    height: 22px;
    line-height: 22px;
    padding-bottom: 10px;
    border-bottom: 1px solid #efefef;
    .card-title {
      position: relative;
      font-size: 16px;
      font-weight: 700;
      > div {
        padding-left: 15px;
      }
    }
    .card-title::before {
      content: "";
      height: 100%;
      background: #036eb8;
      width: 4px;
      position: absolute;
      border-radius: 4px;
    }
    .card-more {
      color: #999;
      font-size: 13px;
      cursor: pointer;
    }
  }
  .card-time {
    display: flex;
    > div {
      padding: 0 10px;
      position: relative;
      cursor: pointer;
    }
    .active::before {
      content: "";
      position: absolute;
      width: 20px;
      height: 3px;
      background-color: #036eb8;
      bottom: -5px;
      left: 8px;
    }
  }
}

.xmDialog-header {
  display: flex;
  justify-content: space-between;
}
.xmDialog-content {
  margin-top: 15px;
}
.xm_item {
  line-height: 36px;
  cursor: pointer;
  font-size: 14px;
  padding-left: 10px;
}
.xm_item:hover {
  background-color: #f2f2f2;
}
#xmbx-box {
  min-height: 500px;
}

.cwzk-more {
  position: absolute;
  right: 15px;
  top: 8px;
}
.xmbx-count {
  text-align: center;
  color: #f59a23;
}
</style>